import majors from "./data/majors.json";
import colleges from "./data/colleges.json";

interface IPresetField {
  title: string;
  description: string;
  dropdownOptions: string[];
  searchable: boolean;
  fieldType: "dropdown";
}

export const presetFields: IPresetField[] = [
  {
    title: "Level of Interest",
    description:
      "A dropdown field with default interest options i.e. 'Actively Looking but Employed' and 'Passive Interest'",
    dropdownOptions: [
      "Actively Looking and Available Immediately",
      "Actively Looking but Employed",
      "Passive Interest",
    ],
    searchable: true,
    fieldType: "dropdown",
  },
  {
    title: "Major",
    description:
      "A dropdown field with default list of college majors i.e. 'Computer Science' and 'Economics'",
    dropdownOptions: majors
      .map((c) => c.majors)
      .flat()
      .sort(),
    fieldType: "dropdown",
    searchable: true,
  },
  {
    title: "US Universities",
    description: "A dropdown field with default list of US universities i.e. 'Harvard University'",
    dropdownOptions: colleges.map((c) => c.institution).sort(),
    fieldType: "dropdown",
    searchable: true,
  },
];
